<template>
  <div class="second-page" ref="secondPage">
    <div class="top">
      <div class="left">
        <CustomTitle :title="'关于玖聚'" :sub-title="'LIAONING JIUJU LAWFIRM'"></CustomTitle>
        <div class="content">
          辽宁玖聚律师事务所成立于2017年1月18号，是辽宁省司法厅核准的合伙制律师事务所。律所秉承“守德、求实、敬业、创新”原则，贯彻“法律公正至上”和“维护当事人最优合法权益”的执业理念，深受当事人和社会各界的一致好评。<br/>
          律所位于沈阳市浑南奥体中心核心板块，办公使用面积500余平，现有执业律师和员工30余名，具备良好的法学素养和丰富的实务经验，主要领域包括民商事诉讼与仲裁、刑事辩护、企业法务合规、企业税务风险防控、知识产权维权、建筑工程和房地产，并具有一支银行金融法律服务团队，对借贷业务和不良资产处置成绩斐然。2022年律所迈向“精细化、专业化、智能化”的高质量发展阶段，为企业客户提供优质、高效、全方位法律服务，致力于构建成辽沈企业可持续发展的法律护城河。
        </div>
        <div class="more" @click="learnMore">了解更多 →</div>
      </div>
      <div class="right">
        <div class="box jingxi">
          <span class="title">精细化</span>
        </div>
        <div class="box zhuanye">
          <span class="title">专业化</span>
        </div>
        <div class="box">
          <span class="title zhineng">智能化</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="text">
        <div class="text-top">构建公平正义之桥</div>
        <div class="text-bottom" @click="contactUs">立即联系我们</div>
      </div>
      <div class="pageNum">
        <img width="26px" @click="goNextPage" height="13px" src="../../assets/homePage/home_icon_npage.png"/>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTitle from '@/components/CustomTitle'
export default {
  name:'cooperativePartner',
  components:{CustomTitle},
  data() {
    return {
    };
  },
  // 在 second-page 组件中
  methods: {
    goNextPage() {
      this.$emit('next-page'); // 触发一个事件，通知父组件跳转到下一页
    },
    learnMore() {
      this.$router.push({
        path: '/aboutJiuju',
      })
    },
    contactUs(){
      this.$router.push({
        path: '/contactUs',
      })
    }
  }

};
</script>

<style lang="scss">
.second-page{
  width: 100%;
  height: 100vh;
  .top{
    display: flex;
    justify-content: space-between;
    height: 75%;
    box-sizing: border-box;
    padding: 10vh 10vw;
    width: 100%;
    .left{
      height: 100%;
      width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      .content{
        margin-top: 3vh;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        margin-bottom: 20px;
        line-height: 34px
      }
      .more {
        margin-top: auto; /* 确保它靠下 */
      }
    }
    .right{
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      margin-left: 5rem;
      justify-content: right;
      align-items: end;
      font-weight: 500;
      font-size: 24px;
      color: #fff;
      position: relative;
      .box{
        width: 23vh;
        height: 23vh;
        margin-left: 1vw;
        background-size: cover;
        position: absolute;
        &:nth-child(1) {
          background: url("../../assets/img/jingxihua.png") no-repeat; /* 第一个 box 背景颜色 */
          background-size: cover;
          top: 5vh;
          right: calc(23vh + 6vh);
        }

        &:nth-child(3) {
          background: url("../../assets/img/zhinenghua.png") no-repeat;
          background-size: cover;
          bottom: 0;
          right: calc(23vh + 2vh);
        }

        &:nth-child(2) {
          background: url("../../assets/img/zhuanyehua.png");
          top: 17vh;
          right: 0;
        }

        .title{
          display: inline-block;
          padding: 24px;
          font-size: 24px;
          color: #fff;
          position: relative; /* 为伪元素提供定位上下文 */
        }

        .title::after{
          content: '';
          position: absolute;
          bottom: -2px;
          left: 24px;
          width: 24px;
          height: 6px;
          background: #FFFFFF;
        }
      }
    }
  }
  .bottom{
    height: 25%;
    background: url("../../assets/img/pageFooterBg.png") no-repeat center center;
    background-size: 100% 100%; /* 确保背景图填满 */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
    position: relative;
    .text{
      margin-right: 10vw;
      .text-top{
        width: 169px;
        height: 22px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 19px;
        text-align-last:justify;
        text-align:justify;
        text-justify:distribute-all-lines; // 这行必加，兼容ie浏览器
      }
      .text-bottom{
        margin-top: 20px;
        text-align: center;
        font-size: 18px;
        line-height: 48px;
        width: 169px;
        height: 48px;
        color: #fff;
        border: 1px solid #D9D9D9;
        cursor: pointer;
      }
    }
    .pageNum{
      width: 100%;
      text-align: center;
      position: absolute;
      bottom: 20px;
      cursor: pointer;
    }
  }
}
</style>
